// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mongosh-shell-loader-shell-loader__1kmFS {\n  border: 2px solid transparent;\n  border-top: 2px solid #c3e7ca;\n  border-radius: 50%;\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  display: inline-block;\n  animation: mongosh-shell-loader-shell-loader-spin__3EqcH 700ms ease infinite;\n}\n@keyframes mongosh-shell-loader-shell-loader-spin__3EqcH {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n", ""]);
// Exports
exports.locals = {
	"shell-loader": "mongosh-shell-loader-shell-loader__1kmFS",
	"shell-loader-spin": "mongosh-shell-loader-shell-loader-spin__3EqcH"
};
module.exports = exports;
